import React from "react";

export const FindNotes = () => {

   return (
       <div>
           Find Notes
       </div>
   )
}